import { render, staticRenderFns } from "./RoomSimpleCard.vue?vue&type=template&id=c1bf2ade&"
import script from "./RoomSimpleCard.vue?vue&type=script&lang=ts&"
export * from "./RoomSimpleCard.vue?vue&type=script&lang=ts&"
import style0 from "./RoomSimpleCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports